import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import cc from 'classcat';
import PropTypes from 'prop-types';
import React from 'react';
import Image from '../Image';
import css from './ImageScroller.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var Column = function Column(_ref) {
  var images = _ref.images,
      columnIndex = _ref.index;
  return /*#__PURE__*/_jsx("ul", {
    className: css.column,
    children: images.map(function (image, imageIndex) {
      return /*#__PURE__*/_jsx("li", {
        className: cc([css.image, css["column-".concat(columnIndex, "-image-").concat(imageIndex)]]),
        children: /*#__PURE__*/_jsx(Image, _objectSpread({}, image))
      }, image.alt);
    })
  });
};

Column.propTypes = {
  images: PropTypes.arrayOf(PropTypes.shape(_objectSpread({}, Image.propTypes))).isRequired,
  index: PropTypes.number.isRequired
};

var ImageScroller = function ImageScroller(_ref2) {
  var headline = _ref2.headline,
      images = _ref2.images;
  return /*#__PURE__*/_jsxs("section", {
    className: css.root,
    children: [/*#__PURE__*/_jsxs("div", {
      className: cc([css.columns, css.desktop]),
      children: [/*#__PURE__*/_jsx(Column, {
        images: images.filter(function (image, imageIndex) {
          return imageIndex < images.length / 2;
        }),
        index: 0
      }), /*#__PURE__*/_jsx(Column, {
        images: images.filter(function (image, imageIndex) {
          return imageIndex >= images.length / 2;
        }),
        index: 1
      }), /*#__PURE__*/_jsx("div", {
        className: css.headline,
        children: /*#__PURE__*/_jsx("h2", {
          dangerouslySetInnerHTML: {
            __html: headline
          }
        })
      })]
    }), /*#__PURE__*/_jsxs("div", {
      className: cc([css.columns, css.mobile]),
      children: [/*#__PURE__*/_jsx("div", {
        className: css.headline,
        children: /*#__PURE__*/_jsx("h2", {
          dangerouslySetInnerHTML: {
            __html: headline
          }
        })
      }), /*#__PURE__*/_jsx(Column, {
        images: images.slice().sort(function (first, second) {
          return first.orderMobile - second.orderMobile;
        }),
        index: 3
      })]
    })]
  });
};

ImageScroller.propTypes = {
  headline: PropTypes.string.isRequired,
  images: PropTypes.arrayOf(PropTypes.shape(_objectSpread({}, Image.propTypes))).isRequired
};
export default ImageScroller;